<template>
  <div id="app">
    <Wizard></Wizard>
  </div>
</template>

<script>
import Wizard from "./components/Wizard.vue";
import { Config, Labels, State, DataLayer, Utils } from "./services.js";

export default {
  name: "app",
  components: { Wizard },
  data () {
    return {
      labels: Labels
    }
  },
  created() {
    console.log("Initializing Antifrogen Sample Submission Wizard application");
    Config.init();
    Labels.init();
    State.init();
  },
  mounted() {
      DataLayer.checkAppVersion().then(({version}) => {
        if (!version || version !== Config.appVersion) {
          Utils.showStatusMessage(Labels.wrongAppVersion, "red");
        }
      }).catch (err => {
        Utils.showStatusMessage(Labels.wrongAppVersion, "red");
      });
  }
};
</script>

<style>
#app {
  font-family: "Gotham SSm A", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin-top: 60px;
}

.assw-messagebox {
  position: fixed;
  top: 100px;
  right: 0;
  background-color: #ffffff;
  max-width: 400px;
  padding: 20px;
  font-family: "Gotham SSm A", Arial, Helvetica, sans-serif;
  box-shadow: 3px 3px rgba(200, 200, 200, 0.4);
  border-left: 1px solid #e4e4e4;
  animation: slide 0.5s forwards;
  transition: opacity 500ms linear;
  opacity: 1;
  z-index: 10001;
}

@keyframes slide {
  0% {
    right: 0;
  }
  100% {
    right: 100px;
  }
}

.assw-messagebox.green {
  border-top: 3px solid green;
}

.assw-messagebox.yellow {
  border-top: 3px solid yellow;
}

.assw-messagebox.red {
  border-top: 3px solid red;
}
</style>
